import { gql } from '@apollo/client';

export const GET_PROPERTY_MESSAGES = gql`
    query PropertyMessages($propertyId: ID!) {
        propertyMessages(propertyId: $propertyId) {
            id
            propertyId
            content
            senderId
            senderName
            senderRole
            createdAt
        }
    }
`;

export const SEND_MESSAGE = gql`
    mutation SendMessage($propertyId: ID!, $content: String!) {
        sendMessage(propertyId: $propertyId, content: $content) {
            id
            propertyId
            content
            senderId
            senderName
            senderRole
            createdAt
        }
    }
`;
